import React, { FC } from "react";
import { Icon, IconProps } from "../Icon";

export const Play: FC<IconProps> = (props) => (
  <Icon {...props}>
   <path fill="currentColor" d="M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2Zm-3.449 9.773-5.22 2.983A.89.89 0 0 1 9 14.983V9.017a.89.89 0 0 1 1.332-.773l5.22 2.983a.89.89 0 0 1-.001 1.546Z"/>
  </Icon>
);

